export default "__VITE_ASSET__DhDDfgah__"